module.exports = __webpack_public_path__ + "img/image-1.1d26350f.png";